module.exports = __webpack_public_path__ + "static/img/3979_phase_function_Paper_Points.ea5c089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3979_phase_function_Paper_Points.png
// module id = OHjS
// module chunks = 0